import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
});

// Attach Bearer token as a fallback for environments where cross-site cookies
// are blocked.
let _token = null;
export function setAuthToken(token) {
  _token = token;
  if (token) {
    api.defaults.headers.common.Authorization = `Bearer ${token}`;
    try { localStorage.setItem("cf_token", token); } catch {}
  } else {
    delete api.defaults.headers.common.Authorization;
    try { localStorage.removeItem("cf_token"); } catch {}
  }
}
export function loadStoredToken() {
  try {
    const t = localStorage.getItem("cf_token");
    if (t) setAuthToken(t);
    return t;
  } catch { return null; }
}
export function getToken() { return _token; }

export function formatApiError(err) {
  const detail = err?.response?.data?.detail;
  if (detail == null) return err?.message || "Something went wrong";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

// Global 402 (subscription locked / plan limit) interceptor —
// redirects to /app/billing with the reason as a toast.
let _subscriptionHandler = null;
export function setSubscriptionHandler(fn) { _subscriptionHandler = fn; }

api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err?.response?.status === 402) {
      const detail = err?.response?.data?.detail || "subscription_locked";
      if (_subscriptionHandler) _subscriptionHandler(detail);
    }
    return Promise.reject(err);
  }
);
